import {
  parseSettingString,
  serializeSettingArray
} from "../scriptsPageutil/serializeSettings";
import { serializeVector, splitVectorParts } from "./vectorRuleUtils";
import { splitConditionalExpression } from "./quantityRuleUtils";

export const DEFAULT_USER_DIMENSIONS = {
  width: 1000,
  height: 1000,
  depth: 1000
};

export function createEmptyScript() {
  return {
    name: "",
    room: "",
    setting: "",
    imageData: null,
    imageContentType: null
  };
}

export function createEmptyScriptItem(overrides = {}) {
  return {
    qty: 1,
    size: "",
    position: [""],
    positionRuleDsl: "",
    rotationRuleDsl: "",
    rotation: ["0,0,0"],
    refScript: "",
    refSettings: [],
    rotable: false,
    kant: "[-,0,0]",
    file: null,
    name: "",
    material: "",
    details: "",
    ...overrides
  };
}

export function createEditableScriptItem(item) {
  return createEmptyScriptItem({
    qty: item.qty,
    size: item.rawSize || item.size || "[100,100,100]",
    position: item.rawPosition,
    positionRuleDsl: item.position || "",
    rotationRuleDsl: item.rotation || "[[0,0,0]]",
    rotation: item.rotation && splitVectorParts(item.rotation).every((part) => part.startsWith("[") || part.startsWith("("))
      ? splitVectorParts(item.rotation)
      : item.rawRotation || [item.rotation || "[0,0,0]"],
    refScript: item.refScript ? String(item.refScript) : "",
    rotable: item.rotable,
    kant: item.kant || "[-,0,0]",
    name: item.name || "",
    material: item.material || "",
    details: item.details || "",
    refSettings: item.refSettings
      ? parseSettingString(item.refSettings).map(({ settingId, value }) => ({
          settingId,
          value
        }))
      : [],
    tempId: item.tempId,
    itemId: item.itemId
  });
}

export const getScriptItemKey = (item) =>
  item.itemId > 0 ? item.itemId : item.tempId;

export const getScriptItemSignature = (item) =>
  `${item.name || ""}|${item.material || ""}`;

export function createScriptSaveData(script) {
  return {
    name: script.name,
    room: script.room,
    setting: script.setting
  };
}

export function createPendingScriptItem({
  item,
  autoIterate,
  positionDSL,
  rotationDSL
}) {
  let [kantType, longEdge, shortEdge] = (item.kant || "[-,0,0]")
    .slice(1, -1)
    .split(",");
  if (kantType === "-") {
    longEdge = "0";
    shortEdge = "0";
  }

  return {
    qty: String(item.qty ?? "0").trim() || "0",
    size: serializeVector(item.size, "100,100,100"),
    position: item.positionRuleDsl
      ? item.positionRuleDsl
      : autoIterate
        ? positionDSL || "[[0,0,0]]"
        : item.position
          .map((position) =>
            position.trim() ? `[${position}]` : "[0,0,0]"
          )
          .join(","),
    rotation: item.rotationRuleDsl || (autoIterate
      ? serializeVector(rotationDSL)
      : item.rotation
          .map((rotation) => {
            const expression = serializeVector(rotation);
            return item.rotation.length > 1 && splitConditionalExpression(expression)
              ? `(${expression})` : expression;
          })
          .join(",")),
    refScript: item.refScript || null,
    refSettings: serializeSettingArray(item.refSettings),
    rotable: item.rotable,
    kant: `[${kantType},${longEdge},${shortEdge}]`,
    name: item.name || "",
    material: item.material || "",
    details: item.details || "",
    tempId: item.tempId || Date.now(),
    itemId: item.itemId || -1
  };
}
